import {lazy} from "react";
import {image, link} from "./widget/image";
import {STORAGE_FRAGMENT} from "./graphql/storage";
const UpdateImage = lazy(() => import("./widget/UpdateImage"));
const Storage = lazy(() => import("./views/storage/Storage"));
const StorageDrawer = lazy(() => import("./widget/StorageDrawer"));


const exports = {
    routes: [
        {
            name: "files",
            path: ["fajlovi", "files"],
            trans: ["Fajlovi", "Files"],
            element: <Storage />,
            layouts: ["cms.CmsLayout"],
            menus: {cmsLeft: {position: 40}},
        },
    ],
    graphql: {
        storage: STORAGE_FRAGMENT
    },
    widgets: {
        image: image,
        link: link,
        StorageDrawer: StorageDrawer,
        UpdateImage: UpdateImage
    }
}
export default exports;